import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { TermosDeUso } from '../pages/TermosDeUso';
// import { LandingPage } from '../pages/LandingPage';
import { PrivacyPage } from '../pages/PrivacyPage';
import { ResponsiveLandingPage } from '../pages/ResponsiveLandingPage';
import { NewFAQ } from '../pages/NewFAQ';

function LandingPageRoutes() {
  return (
    <Routes>

      <Route exact path="/" element={<ResponsiveLandingPage />} />
      {/* <Route path="/land" element={<LandingPage />} /> */}
      <Route path="questoesfrequentes" element={<NewFAQ />} />
      <Route path="termodeuso" element={<TermosDeUso />} />
      <Route path="privacidade" element={<PrivacyPage />} />

    </Routes>
  );
}

export default LandingPageRoutes;
